export default __webpack_public_path__ + "assets/images/2b0ed1e96b595f22b0701ca27bc67255.svg";